import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useExpandableListStyles = makeStyles(
  theme => ({
    expandButton: {
      marginTop: theme.spacing(0.5),
      marginLeft: theme.spacing(-0.5)
    }
  }),
  { name: 'ExpandableList' }
);

export const ExpandableList = ({
  collapseButtonText,
  displayThreshold = 2,
  emptyMessage = null,
  expandButtonText,
  items = [],
  renderItem
}) => {
  const classes = useExpandableListStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!items || items.length === 0) {
    return emptyMessage ? <Typography variant="body2">{emptyMessage}</Typography> : null;
  }

  const displayedItems = isExpanded ? items : items.slice(0, displayThreshold);
  const shouldShowExpandButton = items.length > displayThreshold;

  const handleToggleExpand = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <>
      {displayedItems.map((item, index) => renderItem(item, index, `item-${index}`))}
      {shouldShowExpandButton && (
        <Button
          className={classes.expandButton}
          color="secondary"
          disableRipple
          onClick={handleToggleExpand}
          size="small"
          variant="text"
        >
          {isExpanded ? collapseButtonText : expandButtonText}
        </Button>
      )}
    </>
  );
};
